import { Button, Col, Input, Modal, Tabs, Row, Select, Form } from 'antd';
import React, { Dispatch, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'typesafe-actions';
import { CloseOutlined, CarOutlined } from '@ant-design/icons';
import { ModalTransp } from './styles';
import { selectTransportadoraParceiraRequest } from './../../../../store/ducks/transportadoras/actions';
import { loadRequest } from '../../../../store/ducks/solicitacoesRetorno/actions'
import { ApplicationState } from '../../../../store';
import mask from '../../../../utils/mask';
import { TextLabel } from 'components/TextLabel';
import { SelectTransporter } from './SelectTransporter';
import {
  loadRequestCid,
  stateSelect,
  loadRequestEst,
  clean

} from '../../../../store/ducks/estadoCidade/actions';
import Swal from 'sweetalert2';
import { editarTransportadoraServices } from './services/editarTransportadoraServices';
import { CriaTransportadora } from './services/createTransporter';

interface TranspProps {
  nuNota: number;
}

const ModalTransportadora: React.FC<TranspProps> = ({ nuNota }) => {
  const [form] = Form.useForm();
  const { TabPane } = Tabs;
  const { Option } = Select;
  const dispatch = useDispatch<Dispatch<Action>>();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [radio, setRadio] = useState<any>();
  const [selectedTransporter, setSelectedTransporter] = useState<number>();
  const [loading, setLoading] = useState<boolean>();

  const cddAtivo = useSelector((state: ApplicationState) => state.auth.cddAtivo?.codCdd);
  const estados = useSelector((state: ApplicationState) => state.EstadoCidade.estado);
  const loadEstadoCidade = useSelector((state: ApplicationState) => state.EstadoCidade.loading);
  const cidades = useSelector((state: ApplicationState) => state.EstadoCidade.data);
  const inscricoesAtivas = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);

  const showModal = () => {
    dispatch(selectTransportadoraParceiraRequest(Number(cddAtivo), inscricoesAtivas));
    dispatch(loadRequestEst());
    setIsModalVisible(true);
    setRadio(1);
  };

  const handleCancel = () => {
    dispatch(clean());
    setIsModalVisible(false);
    form.resetFields();
  };

  const handleOk = (values: { nome: string, cnpjCpf: string, estado: number, cidade: number }) => {
    try {
      setLoading(true)

      if (radio === 1) {
        editarTransportadoraServices
          .alterarTransportadoraSolicitacaoRetorno(nuNota, selectedTransporter, selectedTransporter === 0 ? true : false)
          .then((res) => {
            dispatch(loadRequest({}, inscricoesAtivas, cddAtivo))
            Swal.fire({
              title: 'Tansportadora alterada com sucesso',
              timer: 1500,
              icon: 'success',
            });

          })
          .catch((error) => {
            if (error.response.data.Erro) {
              Swal.fire({
                title: 'Opss...',
                showConfirmButton: true,
                html: `${error.response?.data?.Erro}`,
                icon: 'error',
              });

            } else {
              Swal.fire({
                title: 'Não foi possível atualizar a transportadora',
                showConfirmButton: true,
                html: '',
                icon: 'error',
              });
            }
          });


      }

      if (radio === 2) {
        const { nome, cnpjCpf, cidade } = values;
        const cnpjCpfclean = cnpjCpf?.replace(/\D/g, "");

        CriaTransportadora
          .criaTransportadora(inscricoesAtivas, nome, cnpjCpfclean, cidade)
          .then((res) => {
            const transportadora = res.data?.codParceiro;
            editarTransportadoraServices
              .alterarTransportadoraSolicitacaoRetorno(nuNota, transportadora, false)
              .then((res) => {
                dispatch(loadRequest({}, inscricoesAtivas, cddAtivo))
                dispatch(selectTransportadoraParceiraRequest(Number(cddAtivo), inscricoesAtivas));
                Swal.fire({
                  title: 'Tansportadora alterada com sucesso',
                  timer: 1500,
                  icon: 'success',
                });

              })
              .catch((error) => {
                if (error.response.data.Erro) {
                  Swal.fire({
                    title: 'Opss...',
                    showConfirmButton: true,
                    html: `${error.response?.data?.Erro}`,
                    icon: 'error',
                  });

                } else {
                  Swal.fire({
                    title: 'Não foi possível atualizar a transportadora',
                    showConfirmButton: true,
                    html: '',
                    icon: 'error',
                  });
                }
              });
          })
          .catch((error) => {
            if (error.response.data.Erro) {
              Swal.fire({
                title: 'Opss...',
                showConfirmButton: true,
                html: `${error.response?.data?.Erro}`,
                icon: 'error',
              });

            } else {
              Swal.fire({
                title: 'Não foi possível atualizar a transportadora',
                showConfirmButton: true,
                html: '',
                icon: 'error',
              });
            }
          });

      }

      if (radio === 3) {
        editarTransportadoraServices
          .alterarTransportadoraSolicitacaoRetorno(nuNota, selectedTransporter, true)
          .then((res) => {
            dispatch(loadRequest({}, inscricoesAtivas, cddAtivo))
            Swal.fire({
              title: 'Tansportadora alterada com sucesso',
              timer: 1500,
              icon: 'success',
            });

          })
          .catch((error) => {
            if (error.response.data.Erro) {
              Swal.fire({
                title: 'Opss...',
                showConfirmButton: true,
                html: `${error.response?.data?.Erro}`,
                icon: 'error',
              });

            } else {
              Swal.fire({
                title: 'Não foi possível atualizar a transportadora',
                showConfirmButton: true,
                html: '',
                icon: 'error',
              });
            }
          });
      }

    } finally {
      setLoading(false)
      setIsModalVisible(false)
      form.resetFields()
    }
  };

  const onChange = (e: any) => {
    setRadio(+e);
  };

  const handleSelectDataChange = (value: any) => {
    dispatch(stateSelect(value));
    dispatch(loadRequestCid(value));
  };


  const modalSelecionarTransp = (
    <Row gutter={24}>
      <Col md={24} sm={24} xs={24}>
        <Form id="key" name="basic" onFinish={handleOk} layout='vertical' form={form}>
          <Tabs defaultActiveKey="1" onChange={onChange}>

            <TabPane tab="Transportadoras cadastradas" key="1">
              <SelectTransporter setSelectedTransporter={setSelectedTransporter} />
            </TabPane>

            <TabPane tab="Cadastrar transportadora" key="2">

              <Row gutter={24}>
                <Col md={12} sm={24} xs={24}>
                  <Form.Item label={<TextLabel>CNPJ ou CPF</TextLabel>} name="cnpjCpf" rules={[{ required: radio === 2 ? true : false, message: "Campo obrigatório" }]}>
                    <Input
                      placeholder="Digite o CNPJ ou CPF"
                      onChange={(e) => form.setFieldsValue({ cnpjCpf: mask("cnpjCpfInput", e.target.value) })}
                    />
                  </Form.Item>
                </Col>

                <Col md={12} sm={24} xs={24}>
                  <Form.Item label={<TextLabel>Nome</TextLabel>} name="nome" rules={[{ required: radio === 2 ? true : false, message: "Campo obrigatório" }]}>
                    <Input type="text" placeholder="Digite o nome da transportadora" />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={24}>
                <Col md={12} sm={24} xs={24}>

                  <Form.Item label={<TextLabel>Estado</TextLabel>} name="estado" rules={[{ required: radio === 2 ? true : false, message: "Campo obrigatório" }]}>
                    <Select
                      allowClear
                      loading={loadEstadoCidade}
                      placeholder={'Selecione o estado'}
                      onChange={handleSelectDataChange}
                    >
                      {estados?.map((est: any, index) => (
                        <Option value={est?.codUf} key={est?.codUf + index}>
                          {mask("camelCase", est?.descricao)}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>

                </Col>

                <Col md={12} sm={24} xs={24}>

                  <Form.Item label={<TextLabel>Cidade</TextLabel>} name="cidade" rules={[{ required: radio === 2 ? true : false, message: "Campo obrigatório" }]}>
                    <Select
                      showSearch
                      allowClear
                      loading={loadEstadoCidade}
                      disabled={cidades.length === 0 && !loadEstadoCidade}
                      placeholder={'Selecione a cidade'}
                      filterOption={(inputVal, elemen) =>
                        elemen?.props.children.toString().toLowerCase().includes(inputVal?.toLowerCase())
                      }
                    >
                      {cidades?.map((c: any, index) => (
                        <Option value={c.codCid} key={c.codCid + index}>
                          {mask("camelCase", c.nome)}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>

                </Col>
              </Row>

            </TabPane>

            <TabPane tab="Cliente retira" key="3">
              <ModalTransp>
                <p>O cliente vai efetuar a retirada</p>
              </ModalTransp>
            </TabPane>
          </Tabs>
        </Form>
      </Col>
    </Row>
  );

  return (
    <>
      <Button
        type="default"
        size="middle"
        onChange={onChange}
        onClick={() => showModal()}
        block
      >
        <CarOutlined /> Editar transportadora
      </Button>


      <Modal
        centered
        title="Quem vai retirar?"
        visible={isModalVisible}
        cancelText="Cancelar"
        onCancel={handleCancel}
        maskClosable={false}
        closable={true}
        destroyOnClose={true}
        closeIcon={<CloseOutlined />}
        keyboard={true}
        width={800}
        footer={[
          <Button key="back" type="dashed" size="middle" onClick={handleCancel}>
            Cancelar
          </Button>,
          <Button
            form="key"
            type="primary"
            htmlType="submit"
            loading={loading}
          >
            OK
          </Button>,
        ]}
      >
        {modalSelecionarTransp}
      </Modal>
    </>
  );
};

export default ModalTransportadora;
